import { Option } from 'baseui/select';
import * as Yup from 'yup';

export type ReceiptDetailType = {
  isCheck: boolean;
  invoiceNumber: string;
  status: string;
  dueDate: Date | null;
  total: number;
  paidAmount: number;
  saleId: string;
  saleRefId: string;
  id?: string;
};

export type FormType = {
  transactionAt: Date;
  tempTransactionAt: Date;
  needApproval: boolean;
  customerId: string | null;
  customerBillingId: string | null;
  description: string;
  receiptDetails: ReceiptDetailType[];
  customerBillingOptions: Option[];
};

export const receiptSchema = () =>
  Yup.object().shape({
    customerId: Yup.string().nullable().required(),
    customerBillingId: Yup.string().nullable(),
    description: Yup.string().nullable(),
    transactionAt: Yup.date().nullable().required(),
    needApproval: Yup.boolean(),
    receiptDetails: Yup.array().of(
      Yup.object({
        saleId: Yup.string().required(),
        saleRefId: Yup.string().required(),
      }),
    ),
  });
